import calculadoraIcon from "../../../../../assets/icons/calculadora.svg";
import handGreenIcon from "../../../../../assets/icons/hand_green.svg";
import handRedIcon from "../../../../../assets/icons/hand_red.svg";
// import { TabelaParcelas } from "./components/parcelas-tabela";
// import { useState } from "react";
import { ParametroSimulacao } from "./components/simulacao";
import { ResumoAcordo } from "./components/resumo";
import { ContraProposta } from "./components/contra-proposta"
import { ClienteInfo } from "../cliente-info";
import { useModal } from "../../../../../hooks/ModalContext";
import { GenericModal } from "../../../../Modal";
import { useContrato } from "../../../../../context/ContratoContext";
import { useDividas } from "../../../../../context/DividasContext";

export const FormNeg = () => {
  const { setModal, modalInfo, onClose } = useModal();
  const { contratosData } = useContrato()
  const { devedorCadastro, devedor } = useDividas()

  function goToOpeningAccordion(id: string) {
    const element = document.getElementById(id);
    if (element) {
      document.getElementById(id)?.setAttribute("open", "true");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <div className="flex max-h-full flex-col items-center px-2">
      {
        !devedor?.cpf_cnpj && !devedorCadastro?.dadoscadastrais && devedor !== null ? <div className="w-full text-center text-primary font-bold">
          <h3>Clique duas vezes em um dos devedores ao lado para iniciar o atendimento!</h3>
        </div> : !devedorCadastro?.dadoscadastrais && devedor === null ?
          <div className="w-full text-center text-primary font-bold">
            <h3>Esse cliente nao está cadastrado em nosso banco de dados!</h3>
          </div>
          : (
            <>
              <ClienteInfo />

              <h3 className="text-lg font-medium text-gray-700" id="neg-title">
                Detalhamento das Contra Propostas
              </h3>

              {
                contratosData && contratosData?.contratos?.length === 1 ? (<></>) : (
                  <div className="mt-4 flex w-full items-center justify-between px-2 text-sm">
                    <div className="flex  items-center gap-2">
                      <p>Permite junção: </p>
                      <img src={handGreenIcon} alt="" />
                    </div>

                    <div className="flex  items-center gap-2">
                      <p>Não permite junção: </p>
                      <img src={handRedIcon} alt="" />
                    </div>
                  </div>
                )
              }



              <div className="my-2 w-full">

                <ContraProposta />

                <div className="flex items-center gap-6 text-sm">

                  {/* <div className="flex items-center gap-2">
                    <p>Qtd. de contrato(s): </p>
                    <input
                      type="text"
                      placeholder={`${contratosData?.contratos?.length}`}
                      className="w-10 bg-gray-200 px-2 py-0.5 font-medium outline-none"
                      disabled
                    />
                    <input
                      type="text"
                      placeholder="0"
                      className="w-10 bg-blue-200 px-2 py-0.5 font-medium outline-none"

                    />

           
                  </div>
                  <div className="flex items-center gap-2">
                    <p>Qtd. de parcelas(s): </p>
              
                    <input
                      type="text"
                      placeholder={`${contratosData?.contratos[0]?.parcelas?.length}`}
                      className="w-10 bg-gray-200 px-2 py-0.5 font-medium outline-none"
                      disabled
                    />
                    <input
                      type="text"
                      placeholder="0"
                      className="w-10 bg-blue-200 px-2 py-0.5 font-medium outline-none"
                    />
                  </div> */}
                </div>

                {/* <div className="my-4 grid w-full grid-cols-5 place-content-center gap-4 rounded-sm border p-4 text-sm text-gray-800 outline-none">
                 
                  <div className="flex flex-col  ">
                    <p className=" font-medium ">Tipo Neg.: </p>
                    <select className="w-full bg-gray-200 p-1">
                      <option value="AP">AP</option>
                      <option value="AV">AV</option>
                    </select>
                  </div>
                  <div className="flex flex-col ">
                    <p className=" font-medium ">Valor Entrada/AV: </p>
                    <input
                      type="text"
                      className="w-full bg-gray-200 p-1 outline-none"
                    />
                  </div>
                  <div className="flex flex-col ">
                    <p className=" font-medium ">Qtd. Parcela</p>
                    <input
                      type="text"
                      className="w-full bg-gray-200 p-1 outline-none"
                    />
                  </div>
                  <div className="flex  flex-col">
                    <p className="font-medium ">Vencimento.</p>
                    <input
                      type="date"
                      className="w-full bg-gray-200 p-1  outline-none"
                    />
                  </div>
                  <div className="flex flex-col ">
                    <p className=" font-medium ">Forma Pagamento: </p>
                    <select className="w-full bg-gray-200 p-1">
                      <option value="Boleto">Boleto</option>
                      <option value="Crédito">Crédito</option>
                      <option value="Débito">Débito</option>
                      <option value="PIX">PIX</option>
                      <option value="Cheque">Cheque</option>
                    </select>
                  </div>
                </div> */}

                {/* <div className="my-4">
                  <p className="mb-2 w-full text-center text-lg font-medium text-gray-800">
                    Simulação
                  </p>
                  <ParametroSimulacao />
                </div> */}

                <div className="flex items-center gap-4">
                  <button
                    className="flex w-full items-center justify-center gap-2 rounded bg-green-600 p-2 px-4 text-center text-white"
                  // onClick={() => setModal("Erro Acordo", "Erro")}
                  >

                    Aceitar Proposta
                  </button>
                  <button
                    onClick={() => goToOpeningAccordion("resumo")}
                    className="flex w-full items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white"
                  >

                    Contra-Proposta
                  </button>
                  <button
                    onClick={() => goToOpeningAccordion("resumo")}
                    className="flex w-full items-center justify-center gap-2 rounded bg-red-600 p-2 px-4 text-white"
                  >

                    Negar Proposta
                  </button>


                  {/* <button
                    onClick={() => setModal("Tabulação", "Cadastro")}
                    className="flex w-full items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white"
                  >
                    
                    Tabulação
                  </button> */}
                </div>
                {/* <Button name="Sela acordo" /> */}
                {/* <div className="my-4 w-full">
                  <div className="border rounded-md  border-gray-400 px-2 my-2 py-2">

                    <p className="text-sm font-medium text-gray-500">Observação da Análise</p>
                    <textarea className=" block h-[40%] w-full resize-none rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none"  ></textarea>

                  </div>
                </div> */}

                <div className="my-4 w-full">
                  <ResumoAcordo />
                </div>
              </div>

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Tabulação"}
                modalType="Tabulação"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Erro Acordo"}
                modalType="Erro Acordo"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "RetirarTabulacao"}
                modalType="RetirarTabulacao"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Proximo Atendimento"}
                modalType="Proximo Atendimento"
              />
            </>
          )
      }
    </div>
  );
};
